





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import search360Page from '@/api/search360Page';
import { formType } from './types';

@Component
export default class customForm extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => ({}),
  })
  formCustom!: formType

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  inline!: boolean

  @Prop({
    type: String,
    required: true,
    default: '',
  })
  uuid!: string

  ruleCustom = {
    mobile: [{ required: true, message: '请输入您的手机号' }, { validator: this.checkphone, trigger: 'blur', message: '请输入正确的手机号' }],
    captcha: [{ required: true, message: '请输入验证码' }],
    // clueType: [{ required: true, message: '请选择您的合作意向' }],
    budgetScope: [{ required: true, message: '请选择投资预算' }],
  }

  countDownEndTime: number = 0

  countDownSec: number = 60

  SMSStatus: any = {
    text: '获取验证码',
    status: false,
  }

  budgetScopeList = [
    {
      value: '2',
      label: '3万元以下',
    },
    {
      value: '3',
      label: '3万元~6万元',
    },
    {
      value: '4',
      label: '6万元~10万元',
    },
    {
      value: '5',
      label: '10万元以上',
    },
  ]

  validate() {
    return new Promise((resolve, reject) => {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) resolve(valid);
        else reject(valid);
      });
    });
  }

  checkphone(rule: any, value: any, callback: any) {
    if (!/^1\d{10}$/.test(value)) {
      callback(new Error());
    } else {
      callback();
    }
  }

  async clickSuffix() {
    if (this.SMSStatus.status) return false;
    if (!this.formCustom.mobile || !new RegExp(/^1\d{10}$/).test(this.formCustom.mobile)) {
      this.$mtd.message({
        message: '请输入正确的手机号',
        type: 'warning',
      });
      return false;
    }
    const params = {
      mobileNo: this.formCustom.mobile,
      action: 'merchantlandfloor',
      uuid: this.uuid,
    };
    const { error, data }: ApiResponse.MDPData = await search360Page.sendSMSCode(params);
    if (!error && data) {
      if (data.status) {
        this.SMSStatus.status = true;
        this.setCountDown();
      } else {
        this.$mtd.confirm({
          title: '信息提示',
          message: data.errorMessage || '获取验证码失败，请拨打400-061-6300咨询。',
          width: '430px',
          type: 'info',
          okButtonText: '我知道了',
        });
      }
    } else {
      this.$mtd.message({
        message: '获取验证码失败，请重新获取。',
        type: 'warning',
      });
    }
    return true;
  }

  setCountDown() {
    this.countDownEndTime = Date.now() + this.countDownSec * 1000;
    setTimeout(this.countDown);
  }

  countDown() {
    const now = Date.now();
    const sec = Math.ceil((this.countDownEndTime - now) / 1000);
    if (sec > 0) {
      this.SMSStatus.text = `${sec}s后重试`;
      setTimeout(this.countDown, 200);
    } else {
      this.SMSStatus = {
        text: '获取验证码',
        status: false,
      };
    }
  }

  onSubmit() {
    this.$emit('onSubmit', this.inline);
  }
}
